export default __webpack_public_path__ + "static/media/element_spec_58.b222d3e8.webp";